import React from "react";

const Java_Module = () => {
  return (
    <div>
      <h1>Java Module</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Module in Java.</p>
    </div>
  );
};

export default Java_Module;
